const deletePlacesStr = {
  toastr: 'deleted place',
  toastr1: 'successfully deleted'
};

export default deletePlacesStr;
